module.exports = __webpack_public_path__ + "img/akimov.59c0211d.jpg";